import { useRef, useState, useEffect } from "react";
import { toJalali } from "../../utils/moment";
import {
  TrashIcon,
  PencilSquareIcon,
  CheckCircleIcon,
  PlusCircleIcon,
  XMarkIcon,
} from "@heroicons/react/24/solid";
import { checkQuestion } from "../../api/Question";
import GetAdmin from "../../utils/getAdmin";
import AddQuestionForm from "../Forms/addQuestionForm";
import Notification from "../Notification";

const QuestionCardStatic = ({
  item,
  index,
  pageScale,
  setPageScale,
  setDeleteQuestionData,
  setShowDeleteAcception,
  allQuestions,
  setRefresh,
  loadData,
}) => {
  const containerRef = useRef(null);

  const [isChecked, setIsChecked] = useState(item.checkersId?.length !== 0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [adminData, setAdminData] = useState(null);
  const [status, setStatus] = useState();
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [notificationType, setNotificationType] = useState("success");
  const [edit, setEdit] = useState(false);
  const [questionId, setQuestionId] = useState(null);
  const [questionData, setQuestionData] = useState(allQuestions);

  useEffect(() => {
    if (status === 200 || status === 201) {
      setIsModalOpen(false);
      setEdit(false);
      setQuestionId(null);
      setNotificationMessage("موفقیت آمیز بود✅");
      setNotificationType("success");
      setShowNotification(true);
    }
  }, [status]);

  // بستن خودکار نوتیفیکیشن بعد از ۳ ثانیه
  useEffect(() => {
    if (showNotification) {
      const timer = setTimeout(() => {
        setShowNotification(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showNotification]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await GetAdmin();
      setAdminData(res.role);
    };
    fetchData();
  }, []);

  const getBookName = (bookNumber) => {
    switch (String(bookNumber)) {
      case "1":
        return "ریاضی";
      case "2":
        return "فارسی";
      case "3":
        return "علوم";
      case "4":
        return "قرآن";
      case "5":
        return "نگارش";
      case "6":
        return "هدیه";
      case "7":
        return "مطالعات";
      default:
        return "نامشخص";
    }
  };

  const handleCheckToggle = async (id) => {
    try {
      const res = await checkQuestion(id);
      if (res.status === 200) {
        setIsChecked(!isChecked);
        setNotificationMessage("موفقیت آمیز بود✅");
        setNotificationType("success");
        setShowNotification(true);
      } else {
        setNotificationMessage("ثبت تیک ناموفق بود، دوباره امتحان کنید ❌");
        setNotificationType("error");
        setShowNotification(true);
      }
    } catch (error) {
      console.error("❌ خطا در چک کردن سوال:", error);
      setNotificationMessage("خطا در ارتباط با سرور");
      setNotificationType("error");
      setShowNotification(true);
    }
  };

  // باز کردن مودال ویرایش
  const openEditModal = () => {
    setIsModalOpen(true);
    setEdit(true);
    setQuestionId(item._id);
    setQuestionData(allQuestions);
  };

  // بستن مودال
  const closeModal = () => {
    setIsModalOpen(false);
    setEdit(false);
    setQuestionId(null);
  };

  return (
    <div>
      {/* نوتیفیکیشن */}
      {showNotification && (
        <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-[100] w-full max-w-md px-4">
          <Notification
            message={notificationMessage}
            type={notificationType}
            setShowNotification={setShowNotification}
            showNotification={showNotification}
          />
        </div>
      )}

      {/* مودال ویرایش */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4 overflow-y-auto">
          <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            {/* دکمه بستن مودال */}
            <button
              onClick={closeModal}
              className="absolute top-3 left-3 p-2 hover:bg-gray-100 rounded-full transition-colors z-10"
              title="بستن"
            >
              <XMarkIcon className="w-6 h-6 text-gray-500" />
            </button>

            {/* عنوان مودال */}
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 rounded-t-2xl">
              <h3 className="text-lg font-bold text-gray-800">ویرایش سوال</h3>
            </div>

            {/* فرم ویرایش */}
            <div className="p-6">
              <AddQuestionForm
                setStatus={setStatus}
                setShowNotification={setShowNotification}
                setRefresh={() => loadData()}
                edit={edit}
                setEdit={setEdit}
                questionId={questionId}
                questionData={questionData}
              />
              <div className="flex justify-end mt-4">
                <button
                  onClick={closeModal}
                  className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
                >
                  انصراف
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* کارت اصلی سوال */}
      <div
        key={item._id || index}
        className="w-[210mm] max-w-full bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-200 flex flex-col overflow-hidden border border-gray-100"
      >
        {/* سربرگ کارت */}
        <div className="bg-gray-50 px-4 py-2 border-b border-gray-200 flex justify-between items-center">
          <span className="text-xs text-gray-500 font-medium"># {index}</span>
          <span className="text-xs text-gray-400">
            {toJalali(item.created_at || item.createdAt)}
          </span>
        </div>

        {/* متن سوال */}
        <div
          ref={containerRef}
          className="pdf-container flex flex-col items-center overflow-x-hidden"
          dir="rtl"
        >
          <div>
            <div
              className="bg-white shadow-lg rounded-md force-font-important print-section"
              style={{
                width: "210mm",
                display: "inline-block",
                zoom: pageScale,
                boxSizing: "border-box",
                textAlign: "initial",
                position: "relative",
                padding: "5mm 10mm 5mm 10mm",
              }}
            >
              <div className="flex border-2">
                <div
                  style={{
                    flex: "0 0 auto",
                    paddingLeft: "8px",
                    borderLeft: "1px solid black",
                    marginLeft: "8px",
                    width: "30px",
                    textAlign: "center",
                  }}
                  className="flex justify-center items-center"
                >
                  5
                </div>
                <div
                  className="w-full text-gray-800 leading-relaxed"
                  dangerouslySetInnerHTML={{
                    __html: item.content || item.questionText || "",
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* اطلاعات پایین کارت */}
        <div className="bg-gray-50 px-4 py-3 border-t border-gray-200 space-y-2">
          <div className="flex flex-wrap items-center gap-2 text-xs text-gray-600">
            <span className="bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full">
              پایه {item.grade}
            </span>
            <span className="bg-purple-100 text-purple-800 px-2 py-0.5 rounded-full">
              {item.lessonName || "-"}
            </span>
            <span
              className={`px-2 py-0.5 rounded-full font-medium ${
                item.difficulty === "آسان"
                  ? "bg-green-100 text-green-800"
                  : item.difficulty === "متوسط"
                    ? "bg-yellow-100 text-yellow-800"
                    : "bg-red-100 text-red-800"
              }`}
            >
              {item.difficulty || "نامشخص"}
            </span>
            <span className="bg-gray-200 text-gray-700 px-2 py-0.5 rounded-full">
              {getBookName(item.book)}
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-xs text-gray-500">
              نویسنده: {item.creatorName || "نامشخص"}
            </span>
            <div className="flex gap-1 items-center">
              {/* دکمه ویرایش */}
              <button
                className="p-1.5 hover:bg-blue-100 rounded-full transition-colors"
                title="ویرایش"
                onClick={openEditModal}
              >
                <PencilSquareIcon className="h-4 w-4 text-blue-600" />
              </button>
              {adminData === "manager" ? (
                <button
                  className={`p-1.5 rounded-full transition-colors ${
                    isChecked
                      ? "text-green-600 hover:bg-green-100"
                      : "text-gray-400 hover:bg-gray-100"
                  }`}
                  onClick={() => handleCheckToggle(item._id)}
                  title={isChecked ? "برداشتن تیک" : "تیک زدن"}
                >
                  {isChecked ? (
                    <CheckCircleIcon className="h-5 w-5 text-green-600" />
                  ) : (
                    <PlusCircleIcon className="h-5 w-5 text-gray-400" />
                  )}
                </button>
              ) : null}

              {/* دکمه حذف */}
              <button
                className="p-1.5 hover:bg-red-100 rounded-full transition-colors"
                onClick={() => {
                  setDeleteQuestionData(item);
                  setShowDeleteAcception(true);
                }}
                title="حذف"
              >
                <TrashIcon className="h-4 w-4 text-red-600" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionCardStatic;
